<template>
    <v-form :disabled="isEditableForm">
        <v-row>
            <v-col md="12">
                <v-card>
                    <v-dialog
                        transition="dialog-top-transition"
                        max-width="600"
                        v-model="isOpenDialog"
                        persistent
                    >
                        <v-card class="pa-4">
                            <v-row>
                                <v-col md="12">
                                    <h1 class="font-weight-light primary--text">
                                        Tipo de Objetivo
                                    </h1>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="12">
                                    <v-card outlined class="px-4">
                                        <v-row>
                                            <v-col md="12" class="mb-1 mt-1">
                                                <h4
                                                    class="
                                                        font-weight-light
                                                        primary--text
                                                    "
                                                >
                                                    Datos
                                                </h4>
                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                        <v-row class="mb-n7">
                                            <v-col md="12">
                                                <v-text-field
                                                    v-model="Name"
                                                    label="Nombre"
                                                    style="
                                                        padding: 21.1px 0px 17px
                                                            0px;
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-card-actions class="justify-end mb-n4 mr-n6">
                                <v-btn
                                    depressed
                                    color="primary"
                                    @click="submitOrigin"
                                    v-if="!isEditableForm"
                                >
                                    Guardar
                                </v-btn>
                                <v-btn text color="red" @click="closeForm">
                                    Cerrar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
export default {
    name: 'ObjectiveTypesManagementForm',
    data: () => ({}),
    methods: {
        clearFields() {
            this.$store.state.ManagementBase.objectiveTypesManagement.Name = '';
            this.$store.state.ManagementBase.objectiveTypesManagement.Id = '';
        },
        closeForm() {
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/isOpenDialog',
                false
            );
            this.clearFields();
        },
        submitOrigin() {
            if (
                this.$store.state.ManagementBase.objectiveTypesManagement
                    .formType == 'add'
            )
                this.$store.dispatch(
                    'ManagementBase/objectiveTypesManagement/addOrigin'
                );
            else
                this.$store.dispatch(
                    'ManagementBase/objectiveTypesManagement/editOrigin'
                );

            this.closeForm();
        },
    },
    computed: {
        isOpenDialog: {
            get() {
                return this.$store.state.ManagementBase.objectiveTypesManagement
                    .isOpenDialog;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/objectiveTypesManagement/isOpenDialog',
                    val
                );
                this.clearFields();
            },
        },
        Name: {
            get() {
                return this.$store.state.ManagementBase.objectiveTypesManagement
                    .Name;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/objectiveTypesManagement/Name',
                    val
                );
            },
        },
        Id: {
            get() {
                return this.$store.state.ManagementBase.objectiveTypesManagement
                    .Id;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/objectiveTypesManagement/Id',
                    val
                );
            },
        },
        isEditableForm: {
            get() {
                return this.$store.state.ManagementBase.objectiveTypesManagement
                    .isEditableForm;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/objectiveTypesManagement/isEditableForm',
                    val
                );
            },
        },
    },
};
</script>
